import type { SVGProps } from 'react';

export const ResumeNotificationLink = (props: SVGProps<any>) => (
  <svg
    height="18px"
    version="1.1"
    viewBox="0 0 18 18"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'resume watlist link icon'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-848, -438)">
        <g transform="translate(848, 438)">
          <rect height="18" width="18" x="0" y="0"></rect>
          <g transform="translate(2.8955, 3.0802)">
            <path
              d="M9.95337632,0 C10.88637,0 11.6427108,0.785860678 11.6427108,1.75526895 L11.6080341,6.70713539 L11.6427108,6.70713539 C11.5815551,7.2152707 10.2311708,5.39864613 7.34433288,8.62521608 C6.82128468,9.20981822 6.77011485,11.3880806 7.34433288,12.6776194 C7.75289946,13.5951496 9.10378684,14.0421516 8.95593141,14.0421516 L1.68933451,14.0421516 C0.756340824,14.0421516 0,13.2562909 0,12.2868827 L0,5.54286808 C0,5.45382301 2.49729235,6.77224407 3.57737958,6.1171123 C7.7671754,3.57577278 5.7847814,0 5.82135542,0 L9.95337632,0 Z M9.82045431,0.801036096 L6.1391522,0.801036096 C5.99303481,2.38119343 5.61631326,4.28336876 4.46875667,5.09753642 C3.09621553,6.07132596 0.929476857,5.8214448 0.929476857,6.1260809 L0.929476857,12.1632673 C0.929476857,12.7226041 1.35604766,13.1760361 1.88224941,13.1760361 L7.75072709,13.1760361 C8.23233247,13.1760361 6.65018463,11.2021653 7.31428094,8.6902634 C8.25745155,7.65457439 9.03687492,6.94810846 9.65255105,6.5708656 C9.80552956,6.47713117 10.1790882,6.47713117 10.7732269,6.5708656 L10.7732269,1.81380491 C10.7732269,1.29442077 10.4054184,0.866352433 9.93156771,0.807849733 L9.82045431,0.801036096 Z"
              fill="#3D57FF"
              fillRule="nonzero"
            ></path>
            <g
              stroke="#3D57FF"
              strokeLinecap="round"
              strokeWidth="0.84375"
              transform="translate(2.5129, 4.2933)"
            >
              <g transform="translate(2.7821, 0)">
                <line x1="0" x2="3.65183269" y1="0.28125" y2="0.28125"></line>
              </g>
              <g transform="translate(0, 2.8125)">
                <line
                  x1="1.86909494"
                  x2="5.75034494"
                  y1="0.28125"
                  y2="0.28125"
                ></line>
                <line
                  x1="0.1153125"
                  x2="0.4471875"
                  y1="0.282117776"
                  y2="0.282117776"
                ></line>
              </g>
              <g transform="translate(0, 5.44)">
                <line
                  x1="1.86909494"
                  x2="4.42537766"
                  y1="0.466243316"
                  y2="0.466243316"
                ></line>
                <line
                  x1="0.1153125"
                  x2="0.4471875"
                  y1="0.467111092"
                  y2="0.467111092"
                ></line>
              </g>
            </g>
            <ellipse
              cx="10.8787272"
              cy="10.5316137"
              rx="3.80387462"
              ry="3.96629738"
              stroke="#3D57FF"
              strokeWidth="0.84375"
            ></ellipse>
            <path
              d="M10.3952775,11.2803733 L10.3952775,10.8854083 L10.3952775,8.68625443 C10.3952775,8.49365788 10.5514079,8.33752752 10.7440044,8.33752752 C10.936601,8.33752752 11.0927314,8.49365788 11.0927314,8.68625443 L11.0927314,11.1930912 C11.0927314,11.3155897 10.9934267,11.4148944 10.8709281,11.4148944 C10.8600263,11.4148944 10.8491393,11.4140907 10.8383557,11.4124897 L10.6773085,11.3885803 C10.6151741,11.3793557 10.5524442,11.3747245 10.4896288,11.3747245 C10.43752,11.3747245 10.3952775,11.332482 10.3952775,11.2803733 Z"
              fill="#3D57FF"
              fillRule="nonzero"
            ></path>
            <path
              d="M11.3899588,10.1267001 C11.4468683,10.1166654 11.5054709,10.1283806 11.5541488,10.1595232 L11.7659536,10.2950294 C11.9430164,10.4083086 12.0435446,10.6096919 12.0276583,10.8192892 L11.9291472,12.1190001 C11.9128996,12.3333626 11.7307284,12.496915 11.5158608,12.4900465 C11.312108,12.4835332 11.1522137,12.3130789 11.158727,12.1093261 C11.1588868,12.1043286 11.159148,12.0993348 11.1595107,12.094348 L11.2949461,10.231928 C11.2987782,10.1792308 11.3379251,10.135875 11.3899588,10.1267001 Z"
              fill="#3D57FF"
              transform="translate(11.5925, 11.3067) scale(-1, -1) rotate(100) translate(-11.5925, -11.3067)"
            ></path>
          </g>
          <g transform="translate(0.5625, 0.5625)">
            <path
              d="M4.22699607,0 C1.89268481,0 0,1.93317005 0,4.3174131 C0,6.70165616 1.89268481,8.6348262 4.22699607,8.6348262 C6.56130734,8.6348262 8.45399215,6.70165616 8.45399215,4.3174131 C8.45399215,1.93317005 6.56130734,0 4.22699607,0 Z"
              fillRule="nonzero"
              stroke="#26D162"
              strokeWidth="1.125"
            ></path>
            <path
              d="M5.18374224,3.05498448 L6.42437694,5.53625387 C6.5355221,5.7585442 6.44542114,6.02884707 6.22313082,6.13999224 C6.16064587,6.17123471 6.09174499,6.1875 6.02188469,6.1875 L3.54061531,6.1875 C3.29208716,6.1875 3.0906153,5.98602813 3.0906153,5.73749999 C3.0906153,5.6676397 3.10688059,5.59873882 3.13812306,5.53625387 L4.37875776,3.05498448 C4.48990292,2.83269416 4.76020579,2.7425932 4.98249612,2.85373836 C5.06958345,2.89728203 5.14019858,2.96789715 5.18374224,3.05498448 Z"
              fill="#26D162"
              transform="translate(4.7812, 4.2188) rotate(90) translate(-4.7812, -4.2188)"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
